export default "__VITE_ASSET__DsvIy38p__"